const createLink = (linkUrl: string) => {
  const a = document.createElement('a');

  a.style.display = 'none';
  a.href = linkUrl;

  document.body.appendChild(a);

  const clean = () => document.body.removeChild(a);

  return [a, clean] as const;
};

export default createLink;
